// extracted by mini-css-extract-plugin
export default {"Preview":"Preview_gH3PG","outer":"outer_3AxlI","inner":"inner_jVCA9"};